import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How do I access the prompts?',
  a: 'Instantly. After purchase, you will receive a link to a private Notion dashboard and a PDF version containing all 500 prompts. You can duplicate the Notion board to your own workspace.'
}, {
  q: 'Does it work for Claude or Gemini?',
  a: 'Yes! While optimized for ChatGPT, these prompts are engineered using universal AI communication frameworks. They work perfectly on Claude, Gemini, or any other advanced LLM.'
}, {
  q: 'Do I need a paid ChatGPT Plus account?',
  a: 'No. These prompts are designed to get expert-level results even from the free version of ChatGPT (GPT-3.5/GPT-4o mini).'
}, {
  q: 'Is this a subscription?',
  a: 'Absolutely not. This is a one-time payment of $27. You get lifetime access to the prompts and all future updates.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-32 bg-black relative" data-id="element-122">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-123">
        <div className="text-center mb-16" data-id="element-124">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display font-black uppercase text-4xl md:text-5xl text-offwhite tracking-tight leading-[1.05]" data-id="element-125">
            Frequently Asked <span className="text-gold" data-id="element-126">Questions</span>
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-127">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border border-white/10 rounded-xl bg-black-charcoal overflow-hidden" data-id="element-128">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-129">
                <span className="font-bold text-offwhite text-lg" data-id="element-130">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-131" />
              </button>
              <AnimatePresence data-id="element-132">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-133">
                    <div className="px-6 pb-5 text-muted leading-relaxed" data-id="element-134">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}